import { render, staticRenderFns } from "./shareProportion.vue?vue&type=template&id=19c38629&scoped=true&"
import script from "./shareProportion.vue?vue&type=script&lang=js&"
export * from "./shareProportion.vue?vue&type=script&lang=js&"
import style0 from "./shareProportion.vue?vue&type=style&index=0&id=19c38629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c38629",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c38629')) {
      api.createRecord('19c38629', component.options)
    } else {
      api.reload('19c38629', component.options)
    }
    module.hot.accept("./shareProportion.vue?vue&type=template&id=19c38629&scoped=true&", function () {
      api.rerender('19c38629', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/shareProportion.vue"
export default component.exports